module.exports = __webpack_public_path__ + "static/media/corporate-services-img88.4f09089a.jpg";